import { render } from "./Main.vue?vue&type=template&id=03911a84"
import script from "./Main.vue?vue&type=script&lang=ts"
export * from "./Main.vue?vue&type=script&lang=ts"
script.render = render

export default script